import { useParams } from "react-router-dom";
import { useState } from "react";
//import top navbar
import Navbar from "../Navbar/Navbar";

import listOfNews from "./news-list";

//import footer
import Footer from "../footer/footer";

//import css
import "./news.css";

import { Box, Text, Image, Link } from "@chakra-ui/react";
export default function DynamicNews() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { news } = useParams();
  return (
    <>
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {listOfNews
        .filter((element) => element.slug === news)
        .map((item) => {
          return (
            <Box key={item.id} id={item.slug} className="news">
              <Box
                marginY="10px"
                marginX="auto"
                padding="1rem"
                borderBottom="1px solid #afb3b0"
                textAlign="center"
                width={{ base: "94%", md: "80%", lg: "60%", xl: "50%" }}
              >
                <Text fontSize="30px" fontWeight={700}>
                  {item.title}
                </Text>
                <Text fontSize="20px">{item.shortDescription}</Text>
              </Box>
              <Box>
                <Image
                  src={item.image}
                  width={{ base: "94%", md: "80%", lg: "60%", xl: "40%" }}
                  marginY="10px"
                  marginX="auto"
                />
              </Box>
              <Box
                padding="1rem"
                marginY="10px"
                marginX="auto"
                width={{ base: "94%", md: "80%", lg: "60%", xl: "50%" }}
              >
                <Text textAlign="justify">{item.article}</Text>
              </Box>
            </Box>
          );
        })}
      <Box
        padding="1rem"
        borderBottom="1px solid #afb3b0"
        marginY="10px"
        marginX="30px"
        width="50%"
      >
        <Text fontSize="24px" fontWeight={700}>
          See more articles
        </Text>
      </Box>
      <Box
        display="flex"
        flexWrap="wrap"
        margin="1rem"
        padding="1rem"
        gap="30px"
        justifyContent={{ base: "center", md: "flex-start", xl: "flex-start" }}
      >
        {listOfNews
          .filter((element) => element.slug !== news)
          .map((item) => {
            return (
              <Box key={item.id} width={{ base: "80%", md: "40%", xl: "21%" }}>
                <Box marginY="10px">
                  <Image src={item.image} />
                  <Link href={`/news/${item.slug}`}>
                    <Text fontSize="20px" fontWeight={700}>
                      {item.title}
                    </Text>
                  </Link>
                </Box>
              </Box>
            );
          })}
      </Box>
      <Footer />
    </>
  );
}
